module.exports = __webpack_public_path__ + "static/media/Reservation-05.561513e5.svg";